import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Linkedin, Instagram, Youtube, ArrowRight } from "lucide-react";
import { useSite } from "@/lib/site";

export default function SiteFooter() {
  const { settings } = useSite();
  const s = settings || {};
  const social = s.social || {};
  return (
    <footer className="bg-[#0A0A0A] pt-20 pb-8 border-t border-[#C1121F]/30" data-testid="site-footer">
      <div className="container-x grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 bg-[#C1121F] flex items-center justify-center">
              <span className="text-white font-heading font-bold text-lg">D</span>
            </div>
            <div>
              <div className="font-heading font-bold text-white text-base leading-none">DURGA</div>
              <div className="font-heading text-[10px] tracking-[0.22em] text-[#C1121F] uppercase mt-1">Auto Industries</div>
            </div>
          </div>
          <p className="font-body text-sm text-white/60 leading-relaxed mb-6">
            {s.tagline || "Precision Fasteners. Engineered to Last."}
          </p>
          <div className="flex items-center gap-3">
            {social.facebook && <a href={social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="w-9 h-9 border border-[#333] flex items-center justify-center text-white/70 hover:text-white hover:border-[#C1121F] transition-colors"><Facebook size={16} /></a>}
            {social.linkedin && <a href={social.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" className="w-9 h-9 border border-[#333] flex items-center justify-center text-white/70 hover:text-white hover:border-[#C1121F] transition-colors"><Linkedin size={16} /></a>}
            {social.instagram && <a href={social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="w-9 h-9 border border-[#333] flex items-center justify-center text-white/70 hover:text-white hover:border-[#C1121F] transition-colors"><Instagram size={16} /></a>}
            {social.youtube && <a href={social.youtube} target="_blank" rel="noreferrer" aria-label="YouTube" className="w-9 h-9 border border-[#333] flex items-center justify-center text-white/70 hover:text-white hover:border-[#C1121F] transition-colors"><Youtube size={16} /></a>}
          </div>
        </div>

        {/* Quick links */}
        <div>
          <div className="overline mb-5">Company</div>
          <ul className="space-y-3 font-body text-sm">
            {[
              ["About Us", "/about"], ["Industries", "/industries"], ["Case Studies", "/case-studies"],
              ["Knowledge Center", "/blog"], ["Certifications", "/certifications"], ["Contact", "/contact"],
            ].map(([l, t]) => (
              <li key={t}><Link to={t} className="text-white/60 hover:text-[#C1121F] transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>

        {/* Products */}
        <div>
          <div className="overline mb-5">Products</div>
          <ul className="space-y-3 font-body text-sm">
            {[
              ["Hex Bolts", "hex-bolts"], ["Nuts", "nuts"], ["Screws", "screws"],
              ["Washers", "washers"], ["Studs", "studs"], ["Custom", "custom"],
            ].map(([l, slug]) => (
              <li key={slug}><Link to={`/products/category/${slug}`} className="text-white/60 hover:text-[#C1121F] transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <div className="overline mb-5">Get in Touch</div>
          <ul className="space-y-4 font-body text-sm">
            <li className="flex items-start gap-3 text-white/70">
              <MapPin size={16} className="text-[#C1121F] flex-shrink-0 mt-0.5" />
              <span>{s.contact_address || "—"}</span>
            </li>
            <li className="flex items-center gap-3 text-white/70">
              <Phone size={16} className="text-[#C1121F]" />
              <a href={`tel:${s.contact_phone || ""}`} className="hover:text-white">{s.contact_phone}</a>
            </li>
            <li className="flex items-center gap-3 text-white/70">
              <Mail size={16} className="text-[#C1121F]" />
              <a href={`mailto:${s.contact_email || ""}`} className="hover:text-white">{s.contact_email}</a>
            </li>
            <li className="pt-2">
              <Link to="/contact" className="inline-flex items-center gap-2 text-[#C1121F] hover:gap-3 transition-all font-heading font-semibold">
                Request a Quote <ArrowRight size={14} />
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="container-x mt-16 pt-8 border-t border-[#222] flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="font-body text-xs text-white/40">
          © {new Date().getFullYear()} {s.site_name || "Durga Auto Industries"}. All rights reserved.
        </p>
        <div className="flex items-center gap-6 font-body text-xs text-white/40">
          <Link to="/privacy-policy" className="hover:text-white">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-white">Terms & Conditions</Link>
          <Link to="/admin/login" className="hover:text-white">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
